import { c as _c } from "react/compiler-runtime";
import { Text } from '@/components/typography';
import CSOBPojistovnaLogo from '@/assets/logos/csob-pojistovna.svg';
import { TFunction } from 'i18next';
const Disclaimer = t0 => {
  const $ = _c(5);
  const {
    t
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CSOBPojistovnaLogo />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("disclaimer");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="mx-auto flex max-w-192 flex-col items-center gap-4 pb-12">{t1}<Text variant="p3" className="text-center text-gray-900">{t2}</Text></div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default Disclaimer;